import { useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../lib/firebase';
import { REPORT_CALLABLE } from './reportContract';
import { DEADLINE_SHIFT_REPORT_ACTION, type DeadlineShiftResult } from './deadlineShiftContract';

/**
 * Deadlines pushed out (Operations > Overview): estimate and due-date pushes read by comparing
 * consecutive published uploads. Takes no period, like conversion: the history is the run of
 * uploads, and the section says how long that is.
 */
export function useDeadlineShiftReport(companyId: string, adviserId?: string) {
  const [result, setResult] = useState<DeadlineShiftResult | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setResult(null);
    setError(null);
    if (!companyId) {
      setLoading(false);
      return () => { cancelled = true; };
    }
    const call = httpsCallable(functions, REPORT_CALLABLE);
    void call({
      action: DEADLINE_SHIFT_REPORT_ACTION,
      companyId,
      ...(adviserId ? { adviserId } : {}),
    }).then((response) => {
      if (!cancelled) setResult(response.data as DeadlineShiftResult);
    }).catch((err) => {
      if (cancelled) return;
      // Surfaced, never swallowed: an empty table here would read as "nobody pushed a date".
      console.error('[useDeadlineShiftReport] Failed to load deadlines pushed out:', err);
      setError('Deadlines pushed out could not be loaded.');
    }).finally(() => {
      if (!cancelled) setLoading(false);
    });
    return () => { cancelled = true; };
  }, [companyId, adviserId]);
  return { result, loading, error };
}
